// Ticket status badge component
import type { TicketStatus } from '../../../shared/types'
import { useTranslation } from '../../hooks/useTranslation'

interface Props {
  status: TicketStatus
  size?: 'sm' | 'md'
}

const statusColors: Record<TicketStatus, string> = {
  open: 'bg-blue-100 text-blue-800',
  in_progress: 'bg-yellow-100 text-yellow-800',
  pending: 'bg-orange-100 text-orange-800',
  resolved: 'bg-green-100 text-green-800',
  closed: 'bg-gray-100 text-gray-800',
}

export function TicketStatusBadge({ status, size = 'sm' }: Props) {
  const { t } = useTranslation()

  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-2.5 py-1 text-sm'

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${statusColors[status]} ${sizeClasses}`}
    >
      {t(`pages.tickets.statuses.${status}` as any)}
    </span>
  )
}
